import axios from 'axios';

const csrfTokenElement = document.getElementsByName('csrf-token');

if (csrfTokenElement.length) {
  axios.defaults.headers.common = {
    'X-CSRF-TOKEN': csrfTokenElement[0].content
  };
}

const customParamsSerializer = (params) => {
  const isNullOrUndefined = (value) => value === undefined || value === null;

  const serializeArray = (arr, key) => {
    const serializedArray = arr.map((item) => `${key}[]=${encodeURIComponent(JSON.stringify(item))}`).join('&');
    return serializedArray ? `${serializedArray}` : '';
  };

  const collectStr = (value, key) => {
    if (isNullOrUndefined(value)) {
      return '';
    }

    if (Array.isArray(value)) {
      return serializeArray(value, key);
    }

    if (value instanceof Date || value._isAMomentObject) {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value.toISOString())}`;
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      const encodedObject = Object.entries(value).map(([k, v]) => {
        const encodedKey = JSON.stringify(k);
        const encodedValue = encodeURIComponent(JSON.stringify(v));
        return `${encodeURIComponent(`${encodedKey}`)}:${encodedValue}`;
      });

      return encodedObject ? `${key}={${encodedObject}}` : '';
    }

    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  };

  const serialize = (obj, prefix) => {
    const str = [];

    Object.keys(obj).forEach((p) => {
      const key = prefix ? `${prefix}[${p}]` : p;
      const value = obj[p];

      str.push(collectStr(value, key));
    });

    return str.filter(Boolean).join('&');
  };

  return serialize(params);
};

axios.defaults.paramsSerializer = customParamsSerializer;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;

    if (status === 401) {
      // Handle 401 error: redirect to login page
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default axios;
